import { render, staticRenderFns } from "./FluxoTipoEtapaChips.vue?vue&type=template&id=32f2e178&scoped=true"
import script from "./FluxoTipoEtapaChips.vue?vue&type=script&lang=js"
export * from "./FluxoTipoEtapaChips.vue?vue&type=script&lang=js"
import style0 from "./FluxoTipoEtapaChips.vue?vue&type=style&index=0&id=32f2e178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f2e178",
  null
  
)

export default component.exports